/**
 * Resolves effective workspace authority for frontend presentation.
 *
 * The backend remains authoritative on every request. This helper mirrors its
 * organization-admin inheritance so navigation and controls do not disagree
 * with the server while waiting for an operation to be authorized there.
 */
export const canAdministerWorkspace = (
  organizationRoles: string[],
  workspaceRole?: string,
) => organizationRoles.includes('admin') || workspaceRole === 'admin'
